module.exports = __webpack_public_path__ + "img/decor buttons quantity.c5083241.png";